@if (showCookie()) {
    <div
        *transloco="let t"
        class="bazis-cookie"
    >
        <div class="bazis-container">
            <div class="bazis-block bazis-block_shadow">
                <div class="bh-flex">
                    <bazis-icon
                        name="cookie"
                        size="large"
                    ></bazis-icon>
                    <div [innerHTML]="t('cookie', { link: link() })"></div>
                </div>
                <bazis-button
                    color="action"
                    (click)="accept()"
                >
                    {{ t('action.accept') }}
                </bazis-button>
            </div>
        </div>
    </div>
}
